import { useQuery } from "@tanstack/react-query";
import { getHeyApiRequestOptions } from "apiClients/base/heyApiRequestOptions";
import type { ProductCreatedTimeseriesResponse } from "../types";

async function fetchProductCreatedTimeseries(
  months: number,
): Promise<ProductCreatedTimeseriesResponse> {
  const options = getHeyApiRequestOptions();
  const auth = options.auth?.();
  const response = await fetch(
    `${options.baseUrl}/api/statistics/products/timeseries?months=${months}`,
    {
      headers: {
        Accept: "application/json",
        ...(auth ? { Authorization: auth } : {}),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to load product timeseries (${response.status})`);
  }

  return (await response.json()) as ProductCreatedTimeseriesResponse;
}

export function useProductCreatedTimeseriesQuery(months = 12) {
  return useQuery({
    queryKey: ["dashboard-product-timeseries", months],
    queryFn: () => fetchProductCreatedTimeseries(months),
  });
}
